import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        teams: false
      },
      options: {
        teams: []
      },
      selected: {
        team: ''
      },
      editable: {
        team: ''
      }
    }
  },

  methods: {

    async getTeams (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.team
      const fetching = context.fetching?.teams
      const options = context.options?.teams

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.teams = true
      context.selected.team = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getTeams(filters).then(
        ({ data }) => {
          context.options.teams = data
        }
      ).catch(() => {
        context.options.teams = []
      }).finally(() => {
        context.fetching.teams = false
      })
    },

    async searchTeams (search, loading) {
      this.searchTeamsProvider(this, search, loading)
    },

    searchTeamsProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.teams, {
          keys: ['team_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getTeams(filters).then(
            ({ data }) => {
              options.teams = data
            }
          ).catch(() => {
            options.teams = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
